var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "video_svg__videoicon",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 21V3l16 9z",
    stroke: "#000450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJ2aWRlb2ljb24iIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8ZyBpZD0iVmlkZW8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxMTQzIC04NjA2KSI+CiAgICA8cGF0aCBpZD0iSWNvbiIgZD0iTTQsMjFWM2wxNiw5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxMTQzIDg2MDYpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDA0NTAiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPHJlY3QgaWQ9IkNvbnRhaW5lciIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjExNDMgODYwNikiIGZpbGw9Im5vbmUiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgVideo as ReactComponent };